import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Ban, Check, Minus, X } from 'lucide-react';
import type { FC } from 'react';

type TriageCellProps = {
  subscribed: boolean;
  applicabilityStatus: string | null;
  onToggle: (status: 'applicable' | 'not_applicable') => void;
};

export const TriageCell: FC<TriageCellProps> = ({
  subscribed,
  applicabilityStatus,
  onToggle,
}) => {
  if (!subscribed) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center justify-center h-7 w-full rounded bg-neutral-50 text-neutral-300">
            <Minus className="size-3.5" />
          </span>
        </TooltipTrigger>
        <TooltipContent>Not subscribed</TooltipContent>
      </Tooltip>
    );
  }

  if (applicabilityStatus === 'out_of_scope') {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center justify-center h-7 w-full rounded bg-neutral-50 text-neutral-400">
            <Ban className="size-3.5" />
          </span>
        </TooltipTrigger>
        <TooltipContent>Out of scope</TooltipContent>
      </Tooltip>
    );
  }

  const isApplicable = applicabilityStatus === 'applicable';
  const isNotApplicable = applicabilityStatus === 'not_applicable';

  return (
    <div className="flex items-center justify-center gap-0.5">
      <button
        onClick={e => {
          e.stopPropagation();
          onToggle('applicable');
        }}
        className={`inline-flex items-center justify-center h-7 w-7 rounded-l border transition-colors ${
          isApplicable
            ? 'bg-green-100 border-green-300 text-green-700'
            : 'bg-white border-neutral-200 text-neutral-400 hover:bg-neutral-50 hover:text-neutral-600'
        }`}
      >
        <Check className="size-3.5" />
      </button>
      <button
        onClick={e => {
          e.stopPropagation();
          onToggle('not_applicable');
        }}
        className={`inline-flex items-center justify-center h-7 w-7 rounded-r border border-l-0 transition-colors ${
          isNotApplicable
            ? 'bg-red-100 border-red-300 text-red-700'
            : 'bg-white border-neutral-200 text-neutral-400 hover:bg-neutral-50 hover:text-neutral-600'
        }`}
      >
        <X className="size-3.5" />
      </button>
    </div>
  );
};
